export class Path {

  get isEmpty() {
    return this.elements.length === 0;
  }

  get current() {
    return this.elements[0];
  }

  public static parse(path: string): Path {
    const elements = path.split('.');
    return new Path(elements);
  }
  private elements: string[];

  constructor(elements: string[]) {
    this.elements = elements;
  }

  public next() {
    const newPath = new Path(this.elements.slice(1));
    return newPath;
  }
}
